import { TranslatePipe } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component, computed, input, model } from "@angular/core";

import { FirewallSubscriptionDetails } from "../../../pages/subscription-detail/types";
import { TabbedDetailBase } from "../tabbed-detail-container/tabbed-detail-base";
import { descriptionForEntity } from "../tabbed-detail-container/tabbed-detail-container.helpers";
import { FwEndpointPanel } from "./components/fw-endpoint-panel/fw-endpoint-panel";

@Component({
  selector: "fw-detail-container",
  templateUrl: "fw-detail-container.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FwEndpointPanel, TabbedDetailBase, TranslatePipe],
})
export class FwDetailContainer {
  service = input.required<FirewallSubscriptionDetails>();

  protected activeTabIndex = model(0);

  private allEndpoints = computed(() => {
    const service = this.service();
    const l2 = service.l2Endpoints
      .filter((e) => e.otherSubscriptionId?.length)
      .map((e) => ({ endpoint: e, subtitle: "L2VPN Service" }));
    const l3 = service.l3Endpoints
      .filter((e) => e.otherSubscriptionId?.length)
      .map((e) => ({ endpoint: e, subtitle: "L3VPN Service" }));
    return [...l2, ...l3];
  });

  protected navTabs = computed(() =>
    this.allEndpoints().map(({ endpoint, subtitle }) => ({
      title: descriptionForEntity(endpoint),
      subtitle,
    })),
  );

  protected activeEndpoint = computed(() => {
    const all = this.allEndpoints();
    const idx = this.activeTabIndex();
    return idx < all.length ? all[idx].endpoint : null;
  });
}
